module.exports = __webpack_public_path__ + "common/icon-arrow-right-486ab05acf1b21d13820e6f77ae8cb39.svg";